import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';

import * as reducers from './stateManagement/reducer';

export const reduxConfig = ['$ngReduxProvider', $ngReduxProvider => {
    const combinedReducers = {};
    for (const key of Object.keys(reducers)) {
        const newKey = key.replace('Reducer', '');
        combinedReducers[newKey] = reducers[key];
    }

    const reducer = combineReducers(combinedReducers);
    $ngReduxProvider.createStoreWith(reducer, [
        // logger, 
        thunk]);
}];